import { Product } from 'common/components/product-card/types';

export const getGeneralProductIds = (products: Product[]): string[] =>
  products.filter((p) => p?.source?.toUpperCase() !== 'PIM').map((p) => p.productId);
